<template>
  <div class="container">
    <div class="row pt-5 d-flex justify-content-end">
      <div class="col-5 col-md-3 col-lg-3 ml-lg-n14">
        <router-link to="/panelOrderHistory" class="link">
          {{ $t("seeAllCarts") }} &rsaquo;
        </router-link>
      </div>
    </div>
    <div class="row mt-n5">
      <div class="col-lg-3 col-12 b1 h3 gray-text">
        {{ $t("orderDetail") }}
      </div>
      <div v-if="showEdit" class="col-lg-2 col-6">
        <router-link to="/panelNewOrder" class="link"
          ><div class="rounded-pill light-bcg pointer btn py-1 px-3">
            <v-icon class="font14">mdi-pen</v-icon>
            {{ $t("editOrder") }}
          </div></router-link
        >
      </div>
      <div v-if="showEdit" class="col-lg-2 col-6">
        <div
          class="rounded-pill light-bcg pointer btn py-1 px-3 red-text"
          @click="deletecart()"
        >
          <v-icon class="red-text">mdi-delete-outline</v-icon>
          {{ $t("deleteOrder") }}
        </div>
      </div>
      <!-- <div v-if="showEditReciver" class="col-lg-2 col-6">
        <router-link to="/panelNewOrder" class="link"
          ><div class="rounded-pill light-bcg pointer btn py-1 px-3">
            <v-icon class="font14">mdi-pen</v-icon>
            {{ $t("editOrderReciver") }}
          </div></router-link
        >
      </div> -->
    </div>

    <!-- فرم تغییر تحویل کیرنده -->
    <!-- <div class="row">

      <div class="row b1 h5">
        <div class="col-8">{{ $t("orderForm.reciverInfo") }}</div>
        <div class="col-4">
          <v-btn
            v-if="showNewReciverForm"
            @click="showNewReciverForm = false"
            small
            class="blue-border blue-text rounded-pill"
            >{{ $t("preRecivers") }}</v-btn
          >
          <v-btn
            v-if="!showNewReciverForm"
            @click="showNewReciverForm = true"
            small
            class="blue-border blue-text rounded-pill"
            >{{ $t("newReciver") }} +</v-btn
          >
        </div>
      </div>
      <div v-if="showNewReciverForm">
        <div class="row gray-text font14">
          <span>
            <v-checkbox
              v-model="reciverIsMe"
              :label="$t('reciverIsMe')"
            ></v-checkbox
          ></span>
        </div>
        <div class="row" v-if="!reciverIsMe">
          <div class="col-6">
            <v-text-field
              label="نام و نام خانوادگی"
              v-model="reciverForm.name"
              :rules="nameRules"
              hide-details="auto"
            ></v-text-field>
          </div>
          <div class="col-6">
            <v-text-field
              label="شماره موبایل"
              v-model="reciverForm.phoneNumber"
              :rules="phoneNumberRules"
              hide-details="auto"
            ></v-text-field>
          </div>
        </div>
        <div class="row">
          <v-radio-group v-model="tehran" mandatory>
            <v-radio :label="$t('inTehran')" value="inTehran"></v-radio>
            <v-radio :label="$t('notTehran')" value="notTehran"></v-radio>
          </v-radio-group>
        </div>
        <div class="row" v-if="tehran == 'notTehran'">
          <div class="col-6">
            <v-text-field
              v-model="reciverForm.state"
              label="استان"
              hide-details="auto"
            ></v-text-field>
          </div>
          <div class="col-6">
            <v-text-field
              v-model="reciverForm.city"
              label="شهر"
              hide-details="auto"
            ></v-text-field>
          </div>
        </div>

        <div class="row mt-n5">
          <div class="col-12">
            <v-text-field v-model="reciverForm.address" label="نشانی دقیق پستی">
            </v-text-field>
          </div>
        </div>

        <div class="row mt-n10">
          <div class="col-6">
            <div class="row">
              <div class="col-6">
                <v-text-field
                  label="پلاک"
                  maxlength="4"
                  v-model="reciverForm.plaqe"
                ></v-text-field>
              </div>
              <div class="col-6">
                <v-text-field
                  label="واحد"
                  v-model="reciverForm.unit"
                ></v-text-field>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <v-text-field
                  label="کدپستی"
                  v-model="reciverForm.postalcode"
                  maxlength="10"
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
      </div>
      ////////////////////انتخاب دریافت کننده//////////////////// -->
    <!-- <div v-if="!showNewReciverForm">
        <div v-for="reciver in recivers" :key="reciver.id">
          <v-radio-group v-model="choosenReciver">
            <label :for="reciver.id" class="row blue-border p-1 pointer">
              <div class="row">
                <v-radio :value="reciver.id" :id="reciver.id"></v-radio>
              </div>
              <div class="col-4 font-14" align="right" dir="rtl">
                <v-icon>mdi-account-outline</v-icon>{{ reciver.name }}
              </div>
              <div class="col-8 p-6 font-14" align="right" dir="rtl">
                <v-icon>mdi-phone</v-icon> {{ reciver.phone_number }}
              </div>

              <div class="col-12 scrollX font-14 mt-n3" align="right" dir="rtl">
                <v-icon>mdi-map-marker</v-icon>{{ reciver.ostan }}
                {{ reciver.shahr }} {{ reciver.address }} کد پستی
                {{ reciver.code }}
              </div>
            </label>
          </v-radio-group>
        </div>
      </div>
    </div>  -->
    <!-- !پایان انتخاب دریافت کننده  -->

    <div class="row">
      <div class="col-lg-3 col-12">
        <div class="col-12 font19 gray-text">{{ $t("date") }}</div>
        <div class="col-12 font23 b1">{{ info.persian_date }}</div>
      </div>
      <div class="col-lg-3 col-6">
        <div class="col-12 font19 gray-text">{{ $t("expence") }}</div>
        <div class="col-12 font23 b1">{{ info.persian_sum }}</div>
      </div>
      <div class="col-lg-3 col-6">
        <div class="col-12 font19 gray-text">
          {{ $t("orderStatus") }}
        </div>
        <div class="col-12 font23 b1" v-if="info.payment_status == 'PrePay'">
          {{ $t("waitToPay") }}
        </div>
        <div class="col-12 font23 b1" v-if="info.payment_status == 'PayDone'">
          {{ $t("gettingReady") }}
        </div>
        <div class="col-12 font23 b1" v-if="info.payment_status == 'Transfer'">
          {{ $t("waitToDeliver") }}
        </div>
        <div class="col-12 font23 b1" v-if="info.payment_status == 'Done'">
          {{ $t("delivered") }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-3 col-6">
        <div class="col-lg-12 col-12 font19 gray-text">
          {{ $t("trickingCode") }}
        </div>
        <div class="col-lg-12 col-12 font23 b1">
          {{ reciver.tracking_code }}
        </div>
      </div>
      <div class="col-lg-3 col-6">
        <div class="col-lg-12 col-12 font19 gray-text">
          {{ $t("reciverName") }}
        </div>
        <div class="col-lg-12 col-12 font23 b1">{{ reciver.name }}</div>
      </div>
      <div class="col-lg-2 col-6">
        <div class="col-lg-12 col-12 font19 gray-text">
          {{ $t("reciverPhone") }}
        </div>
        <div class="col-lg-12 col-3 font23 b1">{{ reciver.phoneNumber }}</div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 font19 gray-text">{{ $t("address") }}</div>
    </div>
    <div class="row mt-n5 b1 font23">
      <div class="col-12">
        {{ reciver.ostan }}
        {{ reciver.shahr }} {{ reciver.address }} {{ reciver.code }}
      </div>
    </div>
    <div class="row">
      <div class="col-12 b1 font19">
        {{ $t("sentFiles") }}
      </div>
    </div>
    <Factor />
  </div>
</template>
<script>
import Factor from "../../components/Home/factor.vue";
export default {
  data() {
    return {
      showEditReciver: false,
      status: "",
      showEdit: false,
      reciver: {
        tracking_code: "",
        phoneNumber: "",
        name: "",
        address: "",
        ostan: "",
        shahr: "",
        code: "",
      },
      info: {
        id: "",
        date: "",
        payment_status: "",
        price: "",
        paydone_date: "",
        transfer_date: "",
        user: "",
      },
    };
  },
  components: {
    Factor,
  },
  mounted() {
    this.axios.defaults.headers.common["Authorization"] =
      "Bearer " + this.$session.get("token");
    this.axios
      .get("cart/" + this.$session.get("oldCartid"))
      .then((response) => {
        console.log(response.data);
        this.info = response.data;
        if (response.data.payment_status == "PrePay") {
          this.showEdit = true;
          this.status = "PrePay";
        } else {
          this.showEdit = false;
        }
        if (response.data.payment_status == "PayDone") {
          this.showEditReciver = true;
        } else {
          this.showEditReciver = false;
        }
        if (response.data.transferee) {
          this.axios
            .get("transferee/" + response.data.transferee)
            .then((response) => {
              console.log(response.data);
              this.reciver.tracking_code = response.data.tracking_code;
              this.reciver.name = response.data.name;
              this.reciver.phoneNumber = response.data.phone_number;
              this.reciver.shahr = response.data.shahr;
              this.reciver.ostan = response.data.ostan;
              this.reciver.address = response.data.address;
              this.reciver.code = this.$t("postCode") + response.data.code;
            });
        }
      });
    // this.axios
    //   .get("cart/" + this.$session.get("oldCartid"))
    //   .then((response) => {
    //     console.log(response.data.transferee);
    //   });
  },
  methods: {
    deletecart() {
      this.axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$session.get("token");
      this.axios
        .delete("cart/" + this.$session.get("oldCartid"))
        .then((response) => {
          console.log(response);
          this.$session.remove("oldCartid");
          this.$router.push("/panelOrderHistory");
        });
    },
  },
};
</script>
